function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("rect", {
  width: "40",
  height: "40",
  rx: "20",
  fill: "#4462FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.5 25.833h-15a7.482 7.482 0 012.5-5.59v-3.576a5 5 0 0110 0v3.576a7.482 7.482 0 012.5 5.59zm-9.858.834h4.716a2.5 2.5 0 01-4.716 0z",
  fill: "#fff"
}));